import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { colors } from "../../theme";
import { brandTextAccentSx } from "../../utils/brandAssets";
import Logo from "../Logo";
import AuthBrandPanel from "./AuthBrandPanel";
import { buildAuthLink } from "./authHelpers";

const AUTH_ALTERNATE = {
  login: {
    prompt: "Don't have an account?",
    label: "Sign up",
    href: "/signup",
  },
  register: {
    prompt: "Already have an account?",
    label: "Sign in",
    href: "/login",
  },
};

const AuthSplitLayout = ({ mode, searchParams, children }) => {
  const alternate = AUTH_ALTERNATE[mode];
  const alternateHref = buildAuthLink(alternate.href, searchParams);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        minHeight: "100vh",
        bgcolor: colors.background,
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          width: { md: "40%" },
          flexShrink: 0,
          borderRight: `1px solid ${colors.border}`,
        }}
      >
        <AuthBrandPanel mode={mode} />
      </Box>

      <Box
        sx={{
          display: "flex",
          flex: 1,
          minWidth: 0,
          flexDirection: "column",
          bgcolor: colors.background,
        }}
      >
        <Box
          component="header"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            px: { xs: 2.5, md: 4 },
            py: 2,
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Logo sx={{ height: 40, width: "auto" }} />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              ml: "auto",
            }}
          >
            <Typography variant="body2" color="text.secondary">
              {alternate.prompt}
            </Typography>
            <Button
              component={RouterLink}
              to={alternateHref}
              variant="text"
              size="small"
              endIcon={<ArrowForward sx={{ fontSize: 16 }} />}
              sx={{
                ...brandTextAccentSx,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {alternate.label}
            </Button>
          </Box>
        </Box>

        <Box
          component="main"
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2.5, md: 4 },
            py: { xs: 3, md: 4 },
          }}
        >
          <Box sx={{ width: "100%", maxWidth: 440 }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthSplitLayout;
